import { styled } from '@zefr/style-guide';
import Box, { BoxProps } from '@zefr/style-guide/dist/core/Box';
import { MainBody } from '@zefr/style-guide/dist/ui/MainBody';
import { useAtomValue } from 'jotai';
import React from 'react';
import { appAtom } from '../../atoms/appAtom';
import { pageTitleAtom } from '../../atoms/pageTitleAtom';
import { SITE_APP_NONE } from '../../types/shared';
import MarkdownDialog from '../MarkdownDialog';
import SEO from '../SEO';
import TopNav from '../TopNav';

export interface LayoutProps extends BoxProps {}

const Wrapper = styled(Box)(() => ({
  display: 'flex',
  flex: 1,
  [`&.app-${SITE_APP_NONE} > div`]: {
    width: '100%',
  },
  '& .site-layout-container': {
    boxSizing: 'border-box',
    MozBoxSizing: 'border-box',
    WebkitBoxSizing: 'border-box',
  },
}));

const Layout: React.FC<LayoutProps> = ({ children, id = 'site-layout', ...props }) => {
  const pageTitle = useAtomValue(pageTitleAtom);
  const app = useAtomValue(appAtom);

  return (
    <Wrapper component={'section'} className={`site-layout app-${app}`} id={id} {...props}>
      <SEO title={pageTitle} />
      {app === 'NONE' ? (
        children
      ) : (
        <>
          <TopNav />
          <MainBody
            data-testid="layout-main"
            boxSizing={'border-box'}
            className="site-layout-container"
          >
            {children}
          </MainBody>
        </>
      )}
      <MarkdownDialog />
    </Wrapper>
  );
};

export default Layout;
